import styles from '../styles/widget.module.css';
import { APPOINTMENT_HOLD_SECONDS, useCountdown } from '../hooks/useCountdown';

interface AppointmentHoldNoticeProps {
  onExpired?: () => void;
}

export function AppointmentHoldNotice({ onExpired }: AppointmentHoldNoticeProps) {
  const { formattedTime, isExpired } = useCountdown({
    durationSeconds: APPOINTMENT_HOLD_SECONDS,
    onExpired,
  });

  return (
    <p className={styles.confirmHoldNotice}>
      {isExpired ? (
        <>Your appointment hold has expired. Please select a new time.</>
      ) : (
        <>
          Your Appointment is being held for the next <strong>{formattedTime} minutes</strong>
        </>
      )}
    </p>
  );
}
